// extracted by mini-css-extract-plugin
export default {"container":"HO-z","darkBackground":"IO-z","whiteBackground":"JO-z","headerButton":"KO-z","calloutHeading":"LO-z","calloutSubHeading":"MO-z"};